import { basicPathDownloadND } from '../basicPathND';

// Portal detection
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isReadingPlex = hostname.includes('readingplex');

export const fetchGraphicND = async (params) => {
    const path = isReadingPlex ? '/rp-files' : '/mp-files';
    const reqType = 'get';

    const fileParams = {
        fileInfo: {
            fileName: params.fileName,
            type: 'graphic'
        }
    };
    return await basicPathDownloadND(fileParams, path, reqType);
}